module.exports = __webpack_public_path__ + "static/media/recicle.ccb24bc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/recicle.svg
// module id = 165
// module chunks = 0